import React, { useEffect, useState } from 'react';
import AxiosInstance from "../../services/axiosInstance";
import { Toaster } from "../../utility/Toaster";
import { Row, Col, Badge, Card, Spin, Button, Empty, Checkbox } from "antd";
import { RefreshComponet } from "../../utility/UserDetails";
import { useTranslation } from 'react-i18next';
import { CheckCircleFilled, EditOutlined, PlusOutlined } from "@ant-design/icons";
import ReusabaleSignatureModal from '../../components/reuseable/ReusableSignatureModal';

function Medication() {
    const { t } = useTranslation();
    const { Meta } = Card;
    const [warningLoading, setWarningLoading] = useState(false);
    const [medicationList, setMedicationList] = useState([]);
    const [selectedIds, setSelectedIds] = useState([]);
    const [pendingIds, setPendingIds] = useState([]);
    const [sheetSignatureUrl, setSheetSignatureUrl] = useState("");
    const [sheetSignatureDate, setSheetSignatureDate] = useState("");
    const [showClientSignature, setShowClientSignature] = useState(false);

    useEffect(() => {
        getMedications();
    }, []);

    const getMedications = () => {
        setWarningLoading(true);
        let endpoint = "client/medication";
        AxiosInstance.get(endpoint, '')
            .then(res => {
                setWarningLoading(false);
                if (res.data.dirtyBit) RefreshComponet(res.data.dirtyBit);
                if (res.data.success) {
                    setMedicationList(res.data.data);
                    setSelectedIds([]);
                } else {
                    setMedicationList([]);
                    Toaster("error", "Error", res.data.message);
                }
            })
            .catch(error => {
                setWarningLoading(false);
            });
    };

    const signMedication = (signatureDataURL) => {
        if (!pendingIds.length) return;
        setWarningLoading(true);
        let endpoint = "client/sign-multi-medication";
        AxiosInstance.put(endpoint, { cSign: signatureDataURL, ids: pendingIds })
            .then(res => {
                setWarningLoading(false);
                if (res.data.dirtyBit) RefreshComponet(res.data.dirtyBit);
                if (res.data.success) {
                    Toaster("success", "Success", res.data.message);
                    setShowClientSignature(false);
                    setPendingIds([]);
                    setSelectedIds([]);
                    getMedications();
                } else {
                    Toaster("error", "Error", res.data.message);
                }
            })
            .catch(error => {
                setWarningLoading(false);
            });
    };

    const openViewSignature = (url, date) => {
        setSheetSignatureUrl(url);
        setSheetSignatureDate(date);

        setShowClientSignature(true);
    };

    const openSignFor = (ids) => {
        setSheetSignatureUrl("");
        setSheetSignatureDate("");
        setPendingIds(ids);
        setShowClientSignature(true);
    };

    const toggleSelect = (id) => {
        setSelectedIds((prev) =>
            prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
        );
    };

    return (
        <div>
            <Spin spinning={warningLoading} fullscreen size='large' />

            {selectedIds.length > 0 && (
                <Row justify="end" gutter={[16, 16]} style={{ marginTop: 10, marginBottom: 10 }}>
                    <Col>
                        <Button
                            type="primary"
                            className="ant-btn-form"
                            onClick={() => openSignFor(selectedIds)}
                            style={{ backgroundColor: "rgb(0, 165, 255)", display: "flex", alignItems: "center", justifyContent: "center" }}
                            icon={<PlusOutlined />}
                        >
                            {t("Signature")} ({selectedIds.length})
                        </Button>
                    </Col>
                </Row>
            )}

            {medicationList.length === 0 && !warningLoading ? (
                <Empty description={t('No Data Found')} style={{ textAlign: 'center' }} />
            ) : (
                <Row gutter={[16, 16]} className="mt-3" style={{ margin: "0px 0px" }}>
                    {medicationList?.map((item, index) => {
                        const hasSignature = !!item?.cSign;
                        const isChecked = selectedIds.includes(item._id);

                        return (
                            <Col key={item._id ?? index} xs={24} sm={24} md={12} lg={12} xl={8}>
                                <Badge.Ribbon
                                    placement="start"
                                    text={t(item?.med_status)}
                                    color="cyan"
                                >
                                    <Card
                                        className='ant-tabs-tabpane'
                                        style={{
                                            background: "#f0f2f5",
                                            borderLeftWidth: "3px",
                                            borderLeftColor: "cyan",
                                            position: "relative",
                                        }}
                                    >
                                        <Checkbox
                                            checked={isChecked}
                                            disabled={hasSignature}
                                            onChange={() => toggleSelect(item._id)}
                                            style={{ position: "absolute", top: 33, left: 5, zIndex: 2 }}
                                        />

                                        <Meta
                                            description={
                                                <div style={{ fontWeight: 'bold' }}>
                                                    <div style={{ marginTop: 33, marginLeft: '30px', marginBottom: '10px' }}>
                                                        <div>
                                                            <span>{item.medication || "N/A"}</span>
                                                        </div>
                                                        <div>
                                                            {t('Pharmacy')}:
                                                            <span> {item.pharmacy || "N/A"}</span>
                                                            <span style={{ color: 'blue' }}> {item.status || "N/A"}</span>
                                                        </div>
                                                        <div>
                                                            {t('Route')}:
                                                            <span> {item.route || "N/A"}</span>
                                                        </div>
                                                        <div>
                                                            {t('Frequency')}:
                                                            <span> {item.frequency || "N/A"}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                        />

                                        <Button
                                            size="small"
                                            type={hasSignature ? "default" : "primary"}
                                            onClick={() => hasSignature ? openViewSignature(item.cSign, item.cSignDate) : openSignFor([item._id])}
                                            icon={hasSignature ? <CheckCircleFilled style={{ color: "rgb(50, 205, 50)" }} /> : <EditOutlined />}
                                            style={{
                                                position: "absolute",
                                                right: 12,
                                                bottom: 10,
                                                height: 30,
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                padding: "0 12px",
                                                ...(hasSignature
                                                    ? {
                                                        color: "rgb(50, 205, 50)",
                                                        borderColor: "rgb(50, 205, 50)",
                                                    }
                                                    : {
                                                        backgroundColor: "rgb(0, 165, 255)",
                                                    }),
                                            }}
                                        >
                                            {t("Signature")}
                                        </Button>
                                    </Card>
                                </Badge.Ribbon>
                            </Col>
                        );
                    })}
                </Row>
            )}

            {showClientSignature && (
                <ReusabaleSignatureModal
                    open={showClientSignature}
                    title={t("Client Signature")}
                    signatureUrl={sheetSignatureUrl}
                    signatureDate={sheetSignatureDate}
                    loading={warningLoading}
                    onDone={(signatureDataURL) => signMedication(signatureDataURL)}
                    onCancel={() => {
                        setPendingIds([]);
                        setShowClientSignature(false);
                    }}
                />
            )}
        </div>
    );
}

export default Medication;